import React from 'react';
import { TakeOverSource } from '../utils/dialog';
import { TakeOverStatus } from '@/views/PatrolMode/types';
import classNames from 'classnames';
import { clstagStr } from '@/utils/util';
import { CLSTAG } from '@/utils/constant';
import { reportSgmEvent, SgmEventType } from '@/utils/sgm';
interface Props {
  isStoped: boolean;
  operatorIsSelf: boolean;
  takeOverSource: string;
  disabled: boolean;
  takeOverStatus: string;
  vehicleName: string;
  onShowMessage: (name: string) => void;
}
const Control = (props: Props) => {
  const { isStoped, disabled, operatorIsSelf, takeOverStatus, vehicleName } = props;
  const usable =
    operatorIsSelf &&
    isStoped &&
    !disabled &&
    takeOverStatus === TakeOverStatus.TAKEOVER;
  const handleClick = (e: any) => {
    if (usable) {
      reportSgmEvent({
        type: SgmEventType.INFO,
        code: 'monitor_single_vehicle_entry',
        msg: {
          page: 'single_vehicle',
          vehicleName,
          action: 'enter_remote_control',
          trigger: 'click',
          requestId: null,
          result: 'confirmation_opened',
        },
      });
      props.onShowMessage('control');
    } else {
      reportSgmEvent({
        type: SgmEventType.WARN,
        code: 'monitor_single_vehicle_entry',
        msg: {
          page: 'single_vehicle',
          vehicleName,
          action: 'enter_remote_control',
          trigger: 'click',
          requestId: null,
          result: 'blocked',
          reason: 'button_unavailable',
        },
      });
    }
  };
  return (
    <li
      className='item control'
      onClick={handleClick}
      clstag={clstagStr(CLSTAG.RemoteControl)}
    >
      {usable ? <div className='img_normal' /> : <div className='img_gray' />}
      <h3 className='operate_key'>远程遥控</h3>
    </li>
  );
};
export default Control;
